import { gql, graphql } from "react-apollo"
import type { OperationComponent } from "react-apollo"

export const GetUsersQuery = gql`
  query GetUsers($query: String!) {
    users(searchQuery: $query) {
      name
      id
      email
      admin
    }
  }
`
type User = {
  name: string,
  id: string,
  email: string,
  admin: boolean
}

type Response = {
  users: User[]
}

export type InputProps = {
  searchName: string
}

const withUsers: OperationComponent<
  Response,
  InputProps
> = graphql(GetUsersQuery, {
  name: "users",
  options: ({ searchName }) => ({ variables: { query: searchName } })
})

export default withUsers



// WEBPACK FOOTER //
// ./src/Users/queries/withUsers.js